// extracted by mini-css-extract-plugin
export var column = "_sp-0";
export var divider = "_sp-2";
export var timePicker = "_sp-1";